module.exports = __webpack_public_path__ + "img/link.20b5b895.gif";